import React from "react";
import style from "./style.module.scss";
import ExamBlock from "../../components/ExamBlock";
import { Row, Col, Empty, Button } from "antd";
import { ExamItem } from "API";

interface ExamListPagePCProps {
    examList: ExamItem[];
    currentTime: string;
    onTipClick: () => void;
}

const ExamListPagePC: React.FC<ExamListPagePCProps> = ({
    examList,
    currentTime,
    onTipClick
}) => {
    // "1" 考试 2 论文 3 口试

    return (
        <div className={style.main}>
            <div className={style.block}>
                <h1 className={style.subTitle}>
                    考试科目
                    <Button
                        type="link"
                        onClick={onTipClick}
                        className={style.tipBtn}>
                        点击链接查看白果云考试的注意事项
                    </Button>
                </h1>

                <Row gutter={[30, 20]} type="flex">
                    {examList.map((item, index) => (
                        <Col key={index} span={8}>
                            <ExamBlock
                                now={currentTime}
                                platform="PC"
                                className={style.examBlock}
                                name={item.name}
                                type={item.type}
                                title={item.courseName}
                                startDateTime={item.startTime}
                                endDateTime={item.endTime}
                                times={item.times}
                                examId={
                                    item.type !== "3"
                                        ? item.examId
                                        : item.examInfo
                                }
                                examInfo={item}
                            />
                        </Col>
                    ))}
                </Row>

                {examList.length === 0 && <Empty description="暂无考试" />}
            </div>
        </div>
    );
};

export default ExamListPagePC;
